import { TFunction } from 'i18next';
import { Invoice } from '@/features/Profile/sections/Invoices/Invoices.types';

export interface InvoiceDetailsRow {
  label: string;
  value: string;
  isTotal?: boolean;
  hasDividerBefore?: boolean;
}

function isNonEmpty(row: InvoiceDetailsRow): boolean {
  return row.value !== '';
}

export function getInvoiceDetailsRows(
  invoice: Invoice,
  t: TFunction
): InvoiceDetailsRow[] {
  return [
    {
      label: t('pages.cabinet.paid_ads_colon'),
      value: invoice.paidAdsCount?.toString() ?? '',
    },
    {
      label: t('pages.cabinet.paid_services_colon'),
      value: invoice.walletAmount?.toString() ?? '',
    },
    {
      label: t('pages.cabinet.discount_amount_colon'),
      value: invoice.discountPercent ? `${invoice.discountPercent}%` : '',
    },
    {
      label: t('pages.cabinet.package_period_colon'),
      value: invoice.period ?? '',
    },
    {
      label: t('pages.cabinet.customer'),
      value: invoice.customerName ?? '-',
      hasDividerBefore: true,
    },
    { label: t('pages.cabinet.voen'), value: invoice.customerTin ?? '-' },
    {
      label: t('pages.cabinet.contract'),
      value: invoice.contractNumber ?? '-',
    },
    { label: t('pages.cabinet.vat_18'), value: invoice.formattedVatAmount },
    {
      label: t('common.sum'),
      value: invoice.formattedAmount,
      isTotal: true,
      hasDividerBefore: true,
    },
  ].filter(isNonEmpty);
}
